const Notes = () => {
  return (
    <div className="video-notecontainer" >
      <h3>Notes functionality needs to be add</h3>
    </div>
  );
};

export { Notes };
